import HttpClient from "./httpClient";

export interface ResearchReport {
  id: number;
  report_name: string;
  report_type?: "queue" | "msp" | string;
  queue_id: number | null;
  queue_name: string | null;
  timeframe: string | null;
  start_date: string | null;
  end_date: string;
  user_email: string;
  created_at: string;
  updated_at: string;
}

export interface ResearchReportWithData extends ResearchReport {
  analytics_data: any;
}

export interface SaveReportRequest {
  report_type?: "queue" | "msp" | string;
  queue_id?: number | null;
  queue_name?: string | null;
  timeframe?: string | null;
  start_date?: string | null;
  end_date: string;
  analytics_data: any;
  report_name?: string | null;
}

export interface ApiResponse<T> {
  status: "success" | "error";
  data: T;
  timestamp: string;
  error?: string;
}

class ResearchReportApi extends HttpClient {
  public saveReport = async (request: SaveReportRequest): Promise<{ id: number; report_name: string; created_at: string }> => {
    const response: ApiResponse<{ id: number; report_name: string; created_at: string }> = await this.post(`/api/research-reports`, {}, request);
    return response.data;
  };

  public getReports = async (reportType: "queue" | "msp" = "queue"): Promise<{ reports: ResearchReport[] }> => {
    const response: ApiResponse<{ reports: ResearchReport[] }> = await this.get(
      `/api/research-reports`,
      {},
      { report_type: reportType }
    );
    return response.data;
  };

  public getReportById = async (reportId: number): Promise<ResearchReportWithData> => {
    const response: ApiResponse<ResearchReportWithData> = await this.get(`/api/research-reports/${reportId}`);
    return response.data;
  };

  public deleteReport = async (reportId: number): Promise<void> => {
    await this.del(`/api/research-reports/${reportId}`);
  };

  public updateReportName = async (reportId: number, reportName: string): Promise<void> => {
    await this.patch(`/api/research-reports/${reportId}/name`, {}, { report_name: reportName });
  };
}

const researchReportApi = new ResearchReportApi();

export default researchReportApi;
